const moduleName = 'counter';

function counter() {

    document.querySelectorAll('.counter').forEach((counter) => {
        initCounter(counter);
    });

    document.addEventListener('click', function (e) {
        const target = e.target;
        if (target.classList.contains('js-plus')) {
            let wrap = target.closest('.counter'),
                input = wrap.querySelector('input'),
                minLimit = +input.dataset.minLimit,
                maxLimit = +input.dataset.maxLimit,
                step = input.dataset.step ? +input.dataset.step : 1,
                price = parseInt(input.dataset.stepPrice),
                currentVal = parseInt(input.value);
            if (!isNaN(currentVal)) {
                if(currentVal < maxLimit){
                    input.value = currentVal + step;
                    wrap.querySelector('.js-minus').removeAttribute('disabled');
                }
            } else {
                input.value = minLimit;
            }
            if (price) {
               const priceEl = wrap.closest('.js-has-dynamic-price').querySelector('.js-dynamic-price');
                priceEl.textContent = parseInt(priceEl.textContent) + price;
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (target.classList.contains('js-minus')) {
            const wrap = target.closest('.counter'),
                input = wrap.querySelector('input'),
                minLimit = +input.dataset.minLimit,
                step = input.dataset.step ? +input.dataset.step : 1,
                price = parseInt(input.dataset.stepPrice);
            let currentVal = parseInt(input.value);
            if (!isNaN(currentVal) && currentVal > step) {
                input.value = currentVal - step;
                currentVal = parseInt(input.value);
                if(currentVal === minLimit) target.setAttribute('disabled',true);
            } else {
                input.value = minLimit;
                target.setAttribute('disabled',true);
            }
            if (price) {
                const priceEl = wrap.closest('.js-has-dynamic-price').querySelector('.js-dynamic-price');
                priceEl.textContent = parseInt(priceEl.textContent) - price;
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
}

const initCounter = (counter) => {
    const btn = counter.querySelector('.js-minus'),
        input = counter.querySelector('input'),
        minLimit = +input.dataset.minLimit;
    let currentVal = parseInt(input.value);
    if(currentVal === minLimit) btn.setAttribute('disabled',true);
}

export {counter, initCounter}
